// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".press-row{--row-gutter:1.5em;--row-item-size:16rem}.press-row__marquee{align-items:flex-start;display:flex;flex-wrap:nowrap;justify-content:space-around}.press-row__item{flex:0 0 auto;margin-left:var(--row-gutter);margin-right:var(--row-gutter);white-space:normal;width:var(--row-item-size)}@media (min-width:640px){.press-row{--row-gutter:2em}}@media (min-width:1460px){.press-row{--row-item-size:18rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
